module.exports = __webpack_public_path__ + "img/midfoot_strike.eff8880a.svg";